module.exports = __webpack_public_path__ + "img/图片18.8710a2de.png";